import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal, viewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ControlType, TypeForm } from 'src/app/utils/type-form';
import { AoFilterHeaderField } from '../ao-filter-list-header.component';
import { MatMenuTrigger } from '@angular/material/menu';

/**
 * Popup menu for setting filter option on numerical columns.
 * It has two input fields for setting a minimum and maximum number range.
 * It also allows toggling the sorting order and clearing the filter.
 */
@Component({
    selector: 'app-filter-amount',
    templateUrl: './filter-amount.component.html',
    styleUrls: ['./filter-amount.component.scss'],
    standalone: false,
})
export class FilterAmountComponent implements OnInit {
    trigger = viewChild.required(MatMenuTrigger);

    /**
     * The field for which this filter is used
     */
    @Input() field!: AoFilterHeaderField;
    /**
     * The form group with all filter form controls
     */
    @Input() form!: UntypedFormGroup;

    private _filter!: any;
    get filter(): any {
        return this._filter;
    }
    /**
     * The filter value object
     */
    @Input() set filter(value: any) {
        this._filter = value;
        this.setValues();
    }

    /**
     * Unused
     */
    @Output() setAmount = new EventEmitter<void>();
    /**
     * Emitted when the sorting order is changed.
     */
    @Output() sortChange = new EventEmitter<void>();

    public hasValue = signal(false);
    amount = new TypeForm({
        min: {
            type: ControlType.FLOAT,
            control: new UntypedFormControl(),
        },
        max: {
            type: ControlType.FLOAT,
            control: new UntypedFormControl(),
        },
    });

    ngOnInit(): void {
        this.setValues();
        this.hasValue.set(this.amount.value.min != null || this.amount.value.max != null);
    }

    apply() {
        const value = this.amount.value;
        this.form.get(this.field.name)?.setValue(value);
        this.hasValue.set(value.min != null || value.max != null);
        this.trigger().closeMenu();
    }

    setValues(): void {
        const val = this.filter[this.field.name];

        const min = this.amount.getFormControl('min');
        const max = this.amount.getFormControl('max');

        if (!val || val['min'] !== min.value) {
            min.setValue(val ? val['min'] : null, { emitEvent: false });
        }

        if (!val || val['max'] !== max.value) {
            max.setValue(val ? val['max'] : null, { emitEvent: false });
        }
    }

    clear(): void {
        this.amount.reset();
        this.apply();
    }
}
